export enum AccountTypeStatus {
  /* Bank account type statuses */
  Active = 'ACTIVE',
  ComingSoon = 'COMING',
  Inactive = 'INACTIVE',
  /* Client account type statuses */
  Pending = 'PENDING',
  // OPENED, -> move to UNFUNDED
  Unfunded = 'UNFUNDED',
  Other = 'OTHER',
}

export enum AccountTypeFeePeriod {
  Monthly = 'MONTHLY',
  Withdraw = 'WITHDRAW',
  Conditional = 'CONDITIONAL',
}

export enum CaymanAccountTypeName {
  Chequing = 'Chequing',
  EZBanking = 'EZ Banking',
  Caymanite = 'Caymanite',
  GenNow = 'GenNow',
}

export enum AccountType {
  Checking = 'CHQ',
  Savings = 'SAV',
}

export type AccountTypeDetails = {
  id: string;
  name: string;
  classCode: number;
  type: string;
  description: string;
  status: AccountTypeStatus;
  apr?: number;
  highlight: string;
  detail: string;
  fee?: string;
  headline?: string;
  feeCurrency?: string;
  feePeriod?: AccountTypeFeePeriod;
  conditionalNote?: string;
  additionalInfo?: string;
  operationId?: string;
  isEligible?: boolean;
  reachedMaxAccountsPerType?: boolean;
  primaryAccount?: boolean;
  secondaryAccount?: boolean;
  accountNo?: string;
  estimatedMonthlyDepositAmount?: number;
  estimatedMonthlyDepositCount?: number;
  estimatedMonthlyCashDepositAmount?: number;
  willSendReceiveFromOthers?: boolean;
  willUseInternationalWireTransfers?: boolean;
  isBusinessPurpose?: boolean;
  fundingSource?: string;
  fundingSourceUpdatedInRemediation?: boolean;
  estimatedMonthlyDepositAmountUpdatedInRemediation?: boolean;
};
